import { Box, SxProps, Theme, Typography } from '@mui/material'
import { formatValue } from '../../app/utils'

interface InfoNumberDisplayItemProps {
  label: string
  value: string | number
  unit?: string
  isSmallScreen: boolean
  sx?: SxProps<Theme>
  formatOptions?: {
    minimumFractionDigits?: number
    maximumFractionDigits?: number
    locale?: string
  }
}

const InfoNumberDisplayItem: React.FC<InfoNumberDisplayItemProps> = ({
  label,
  value,
  isSmallScreen,
  unit,
  sx,
  formatOptions,
}: InfoNumberDisplayItemProps) => {
  return (
    <Box display='flex' alignItems='center' minWidth={isSmallScreen ? '100%' : '200px'}>
      <Typography
        variant='subtitle1'
        sx={{ fontWeight: 700, color: '#636363', textAlign: 'left', whiteSpace: 'nowrap' }}
      >
        {label}:{' '}
      </Typography>
      <Typography
        component='span'
        variant='subtitle1'
        color='textSecondary'
        sx={{ marginLeft: '4px', whiteSpace: 'nowrap' }}
      >
        {formatValue(value, formatOptions)} {unit && value ? `${unit}` : 'N/A'}
      </Typography>
    </Box>
  )
}

export default InfoNumberDisplayItem
